import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const { t } = useLanguage();

  const questions = t('faq.questions');

  return (
    <div className="min-h-screen bg-[#0B1220] pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-yamai-cyan-500/20 to-yamai-purple-500/20 border border-yamai-cyan-400/30 mb-6">
            <HelpCircle className="w-8 h-8 text-yamai-cyan-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('faq.title')}
          </h1>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-[#1F2A3A]/50 backdrop-blur-md rounded-2xl border border-white/10 p-8">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {questions.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-b border-white/10 last:border-0"
              >
                <AccordionTrigger className="text-left text-white hover:text-yamai-cyan-400 transition-colors py-4">
                  <span className="text-lg font-semibold">{item.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 leading-relaxed pb-4">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-yamai-cyan-500/10 to-yamai-purple-500/10 border border-yamai-cyan-400/30 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-3">
              Still have questions?
            </h3>
            <p className="text-gray-400 mb-6">
              Can't find the answer you're looking for? Please reach out to our team.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-yamai-cyan-500 to-yamai-purple-600 text-white font-semibold hover:shadow-lg hover:shadow-yamai-cyan-500/50 transition-all duration-300"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
